import React, { useState, useEffect, useRef } from "react";
import ReelCard from "./ReelCard";
import ReelModal from "./ReelModal";
import { getInstagramReels } from "./apicall";
import "./ReelsCarousel.css";

const ReelsCarousel = () => {
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // selectedIndex: null means modal is closed. A number means modal is open at that index.
  const [selectedIndex, setSelectedIndex] = useState(null);

  const scrollRef = useRef(null);

  useEffect(() => {
    const fetchReels = async () => {
      try {
        const result = await getInstagramReels();

        if (result.success && result.data) {
          setReels(result.data);
        } else {
          setReels([]);
        }
      } catch (err) {
        console.error("Error loading reels:", err);
        setError("Unable to load Instagram Reels right now.");
      } finally {
        setLoading(false);
      }
    };

    fetchReels();
  }, []);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -235, behavior: "smooth" }); // Scroll 1 reel (approx 220px + 15px gap)
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 235, behavior: "smooth" }); // Scroll 1 reel
    }
  };

  const openModal = (index) => {
    setSelectedIndex(index);
  };

  const closeModal = () => {
    setSelectedIndex(null);
  };

  const handlePrev = () => {
    if (selectedIndex > 0) {
      setSelectedIndex(selectedIndex - 1);
    }
  };

  const handleNext = () => {
    if (selectedIndex !== null && selectedIndex < reels.length - 1) {
      setSelectedIndex(selectedIndex + 1);
    }
  };

  if (loading) {
    return (
      <div className="reels-carousel-container">
        <div className="reels-section-header">
          <h2>Our Instagram Reels</h2>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (error || reels.length === 0) {
    // Graceful fallback if API fails or no reels exist
    return null;
  }

  return (
    <div className="reels-carousel-container container">
      <div className="reels-section-header">
        <h2>Follow Our Journey</h2>
      </div>

      <div className="reels-row-wrapper">
        <div className="reels-scroll-row" ref={scrollRef}>
          {reels.map((reel, index) => (
            <ReelCard
              key={reel.id || reel.instagram_id || index}
              reel={reel}
              onClick={() => openModal(index)}
            />
          ))}
        </div>
      </div>

      <div className="reels-nav-container">
        <button
          className="reels-nav-btn"
          onClick={scrollLeft}
          aria-label="Scroll left"
        >
          &#8249;
        </button>
        <button
          className="reels-nav-btn"
          onClick={scrollRight}
          aria-label="Scroll right"
        >
          &#8250;
        </button>
      </div>

      {/* Modal is rendered outside the normal flow if selectedIndex is not null */}
      {selectedIndex !== null && reels[selectedIndex] && (
        <ReelModal
          reel={reels[selectedIndex]}
          onClose={closeModal}
          onPrev={handlePrev}
          onNext={handleNext}
          hasPrev={selectedIndex > 0}
          hasNext={selectedIndex < reels.length - 1}
        />
      )}
    </div>
  );
};

export default ReelsCarousel;
